<template>
  <div>
    PPS
  </div>
</template>
<script>
export default {
  name: "PPS",
};
</script>
